import { usePunditUserContext } from "@circle-react/contexts";

export const useAiSummariesEnabled = (): boolean => {
  const { currentCommunitySettings, currentCommunityMember } =
    usePunditUserContext();
  const isFlagEnabled = currentCommunitySettings?.ai_spaces_summaries_enabled;
  const isFeatureSupported =
    currentCommunityMember?.policies?.can_summarize_spaces;

  return Boolean(isFlagEnabled && isFeatureSupported);
};
